import { PropsWithChildren } from 'react'
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'
import { ErrorBoundaryComponent } from './ErrorBoundaryComponent'
export * from './TopLevelErrorBoundary'

export function ErrorBoundary(props: PropsWithChildren) {
  return (
    <ReactErrorBoundary FallbackComponent={ErrorBoundaryComponent}>
      {props.children}
    </ReactErrorBoundary>
  )
}
